/* src/app/main/pages/services/ocean-service/ocean-service-content/ocean-service-content.component.css */
.main-div .number {
  color: rgb(227 100 10 / 0.77);
  padding-right: 6px;
}
.main-div .bg-img-top::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/bg-triangle.png);
  right: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 300px;
  top: 0px;
}
.main-div .bg-img-bottom::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/services-bg-triangle.png);
  right: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 300px;
  bottom: -60px;
}
.arrow-overlap-img:before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/overlap-arrow-1.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 240px;
  bottom: 0px;
}
.arrow-overlap-img-top:before {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/arrow-overlap-top.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 240px;
  top: 0px;
}
.service-sub-full-bg {
  background-image:
    linear-gradient(
      to left,
      rgb(255 255 255 / 0),
      rgb(33 54 84 / 1)),
    url(/assets/images/our-services/ocean-service/rail-transport.png);
  background-position: center;
  background-size: cover;
  padding-top: 80px;
  padding-bottom: 110px;
  position: relative;
}
@media all and (-ms-high-contrast: none) {
  .service-sub-full-bg {
    background-image: url(/assets/images/our-services/ocean-service/rail-transport.png);
  }
}
.service-sub-full-bg::before {
  content: "";
  position: absolute;
  background-color: #E8882D;
  width: 370px;
  height: 5px;
  top: 0;
}
.service-sub-full-bg::after {
  content: "";
  position: absolute;
  background-image: url(/assets/images/our-services/ocean-service/before-triangle.png);
  left: 0;
  background-repeat: no-repeat;
  background-size: 200px auto;
  width: 200px;
  height: 100%;
  top: -18px;
}
@media (min-width: 1680px) {
  .main-div h2,
  .service-sub-full-bg h2 {
    margin-bottom: 25px !important;
  }
  .main-div p,
  .service-sub-full-bg p {
    font-size: 21px;
  }
}
@media (min-width: 1600px) and (max-width: 1679px) {
  .main-div p,
  .service-sub-full-bg p {
    font-size: 21px;
  }
}
@media (device-width: 1280px) {
  .main-div .bg-img-bottom::after {
    bottom: -70px;
  }
}
@media (max-width: 1024px) {
  .main-div p {
    margin-bottom: 50px;
  }
}
@media (max-width: 767px) {
  .service-sub-full-bg::before {
    width: 170px;
  }
  .service-sub-full-bg {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
/*# sourceMappingURL=ocean-service-content.component.css.map */
